document.addEventListener('DOMContentLoaded', function() {
    /*
     * The fan's club, off window.urcAuth.
     *
     * It was `getCookie('auth0_team_id') || window.userTeamId || document.body.dataset.userTeamId`.
     * The cookie is gone; **the two fallbacks were already dead and worth recording as such** --
     * nothing in this theme assigns `window.userTeamId` or a `data-user-team-id` on `<body>`, so
     * the cookie was the only working source and a reader would have concluded otherwise.
     *
     * `state()` answers null until the SDK settles and `clubId` is a NUMBER, so it is stringified:
     * every consumer below interpolates it into a class name.
     *
     * **The signed-out path now STRIPS rather than returning early**, and that is required rather
     * than tidy. This page is edge cached and PHP used to bake `user-team-highlight team-N` into
     * the markup, so an entry cached before this change still carries one fan's classes for the
     * whole of its TTL. Bailing on "no club" would leave them on screen for everybody served it.
     */
    function currentClubId() {
        const api = window.urcAuth;
        const state = api && typeof api.state === 'function' ? api.state() : null;

        return state && state.signedIn && state.clubId ? String(state.clubId) : '';
    }
    
    // Function to apply team highlighting
    function applyTeamHighlighting() {
        const userTeamId = currentClubId();
        const fixtureCards = document.querySelectorAll('.fixture-card');

        fixtureCards.forEach(card => {
            // Every stale class first, whatever club it names, then this fan's if there is one.
            // A cached render can carry another fan's, and a fan who has just changed club can
            // carry their own previous one.
            card.classList.remove('user-team-highlight');
            [ ...card.classList ]
                .filter(name => /^team-\d+$/.test(name))
                .forEach(name => card.classList.remove(name));

            if (!userTeamId) {
                return;
            }

            const homeTeamBg = card.querySelector(`.home-team-bg-${userTeamId}`);
            const awayTeamBg = card.querySelector(`.away-team-bg-${userTeamId}`);

            if (homeTeamBg || awayTeamBg) {
                card.classList.add('user-team-highlight', `team-${userTeamId}`);
            }
        });
    }
    
    // Add hover effect for clickable cards
    function addCardHoverEffects() {
        const fixtureCards = document.querySelectorAll('.fixture-card');
        
        fixtureCards.forEach(card => {
            const link = card.querySelector('.fixture-card-link');
            if (link) {
                // Add hover effect
                card.addEventListener('mouseenter', function() {
                    // this.style.transform = 'scale(1.02)';
                    // this.style.transition = 'transform 0.2s ease';
                });
                
                card.addEventListener('mouseleave', function() {
                    // this.style.transform = 'scale(1)';
                });
            }
        });
    }
    
    // Main fixtures UI initialization function
    function initializeFixturesUI() {
        const tabsMenu = document.querySelector('.fixtures-rounds-menu');
        const roundTabs = document.querySelectorAll('.round-link');
        const fixtureContainers = document.querySelectorAll('.round-fixtures');
        const heading = document.querySelector('.slider-heading');
        const tabLeftArrow = document.querySelector('.fixtures-tabs .scroll-arrow.left');
        const tabRightArrow = document.querySelector('.fixtures-tabs .scroll-arrow.right');

        // Function to update arrow states with display visibility
        const updateArrowStates = (container, leftArrow, rightArrow) => {
            if (!container || !leftArrow || !rightArrow) return;
            
            const scrollLeft = container.scrollLeft;
            const maxScroll = container.scrollWidth - container.clientWidth;
            
            // Use style.display instead of disabled property for better UX
            leftArrow.style.display = scrollLeft <= 0 ? 'none' : 'block';
            rightArrow.style.display = scrollLeft >= maxScroll - 1 ? 'none' : 'block';
        };

        // Function to scroll by a specific amount
        const scrollByAmount = (container, amount) => {
            container.scrollBy({ left: amount, behavior: 'smooth' });
        };

        // Function to switch to a specific round
        const switchToRound = (roundItem) => {
            const round = roundItem.dataset.round;
            const tab = roundItem.querySelector('.round-link');
            
            // Update active tab
            roundTabs.forEach(link => link.classList.remove('active'));
            tab.classList.add('active');
            
            // Update fixtures display
            fixtureContainers.forEach(container => (container.style.display = 'none'));
            const target = document.getElementById(`round-${round}`);
            if (target) target.style.display = 'block';
            
            // Instead of scrollIntoView, just scroll the tabs menu horizontally
            // to center the tab without affecting the page scroll position
            if (tabsMenu) {
                const itemLeft = roundItem.offsetLeft;
                const menuWidth = tabsMenu.clientWidth;
                const itemWidth = roundItem.offsetWidth;
                const scrollPosition = itemLeft - (menuWidth / 2) + (itemWidth / 2);
                
                tabsMenu.scrollTo({
                    left: scrollPosition,
                    behavior: 'smooth'
                });
            }

            // Update heading
            if (heading) {
                heading.textContent =
                    round <= 18 ? `Round ${round} Fixtures` :
                    round == 19 ? 'QF Fixtures' :
                    round == 20 ? 'SF Fixtures' :
                    round == 21 ? 'GF Fixtures' :
                    `Round ${round} Fixtures`;
            }

            // Reset scroll position and update arrow states for the newly displayed fixtures track
            const track = target && target.querySelector('.fixtures-track');
            if (track) {
                // Check if this round has live matches, if so scroll to them, otherwise start at beginning
                const liveMatches = target.querySelectorAll('.fixture-card.fixture-live');
                if (liveMatches.length > 0) {
                    // Auto-scroll to live matches after a short delay to ensure DOM is ready
                    setTimeout(() => {
                        autoScrollToLiveMatch();
                    }, 50);
                } else {
                    track.scrollLeft = 0;
                }
                
                const container = track.closest('.fixtures-track-container');
                const left = container && container.querySelector('.scroll-arrow.left');
                const right = container && container.querySelector('.scroll-arrow.right');
                updateArrowStates(track, left, right);
            }
        };

        // Handle round item click
        document.querySelectorAll('.round-item').forEach(item => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                switchToRound(item);
            });
        });

        // Round menu scroll functionality
        if (tabsMenu && tabLeftArrow && tabRightArrow) {
            // Initial arrow states
            updateArrowStates(tabsMenu, tabLeftArrow, tabRightArrow);
            
            // Handle arrow clicks
            tabLeftArrow.addEventListener('click', () => scrollByAmount(tabsMenu, -200));
            tabRightArrow.addEventListener('click', () => scrollByAmount(tabsMenu, 200));
            
            // Update arrow states on scroll and resize
            tabsMenu.addEventListener('scroll', () => updateArrowStates(tabsMenu, tabLeftArrow, tabRightArrow));
            window.addEventListener('resize', () => updateArrowStates(tabsMenu, tabLeftArrow, tabRightArrow));
        }

        // Fixtures track scroll functionality
        document.querySelectorAll('.fixtures-track-container').forEach(container => {
            const track = container.querySelector('.fixtures-track');
            const left = container.querySelector('.scroll-arrow.left');
            const right = container.querySelector('.scroll-arrow.right');
            
            if (!track || !left || !right) return;
            
            // Initial arrow states
            updateArrowStates(track, left, right);
            
            // Handle arrow clicks with larger scroll amount for fixtures
            left.addEventListener('click', () => scrollByAmount(track, -300));
            right.addEventListener('click', () => scrollByAmount(track, 300));
            
            // Update arrow states on scroll and resize
            track.addEventListener('scroll', () => updateArrowStates(track, left, right));
            window.addEventListener('resize', () => updateArrowStates(track, left, right));
        });

        // Handle initial active tab scroll and auto-scroll to live matches
        const activeTab = document.querySelector('.round-link.active');
        const currentActiveRound = document.querySelector('.current-active-round');
        
        if (activeTab) {
            // Scroll the tab menu to center the active tab without affecting page scroll
            const activeRoundItem = activeTab.closest('.round-item');
            if (activeRoundItem && tabsMenu) {
                const itemLeft = activeRoundItem.offsetLeft;
                const menuWidth = tabsMenu.clientWidth;
                const itemWidth = activeRoundItem.offsetWidth;
                const scrollPosition = itemLeft - (menuWidth / 2) + (itemWidth / 2);
                
                tabsMenu.scrollTo({
                    left: scrollPosition,
                    behavior: 'smooth'
                });
            }
        } else if (currentActiveRound) {
            const tab = currentActiveRound.querySelector('.round-link');
            if (tab) {
                tab.classList.add('active');
                
                // Scroll the tab menu to center this tab
                if (tabsMenu) {
                    const itemLeft = currentActiveRound.offsetLeft;
                    const menuWidth = tabsMenu.clientWidth;
                    const itemWidth = currentActiveRound.offsetWidth;
                    const scrollPosition = itemLeft - (menuWidth / 2) + (itemWidth / 2);
                    
                    tabsMenu.scrollTo({
                        left: scrollPosition,
                        behavior: 'smooth'
                    });
                }
                
                const round = currentActiveRound.dataset.round;
                const targetContainer = document.getElementById('round-' + round);
                if (targetContainer) {
                    fixtureContainers.forEach(container => {
                        container.style.display = 'none';
                    });
                    targetContainer.style.display = 'block';
                }
            }
        }

        // Apply team highlighting after initialization
        applyTeamHighlighting();
        
        // Add hover effects for clickable cards
        addCardHoverEffects();
        
        // Auto-scroll to live matches after initialization (delayed to allow Firebase to sync)
        setTimeout(() => {
            autoScrollToLiveMatch();
        }, 300);
    }
    
    // Initialize on page load - no delay needed as we're in DOMContentLoaded
    initializeFixturesUI();
    
    // Debounce function to prevent too frequent UI updates
    function debounce(func, wait) {
        let timeout;
        return function executedFunction() {
            const args = arguments;
            const later = () => {
                clearTimeout(timeout);
                func.apply(this, args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }
    
    // Handle UI updates with debounced reinitialization
    const debouncedInit = debounce(() => {
        // Reinitialize after updates
        initializeFixturesUI();
        
        // Apply team highlighting after updates
        applyTeamHighlighting();
        
        // Add hover effects after updates
        addCardHoverEffects();
        
        // Auto-scroll to live matches after updates
        autoScrollToLiveMatch();
        
        // Update arrow states after content is updated
        const tabsMenu = document.querySelector('.fixtures-rounds-menu');
        const tabLeftArrow = document.querySelector('.fixtures-tabs .scroll-arrow.left');
        const tabRightArrow = document.querySelector('.fixtures-tabs .scroll-arrow.right');
        
        const updateArrowStates = (container, leftArrow, rightArrow) => {
            if (!container || !leftArrow || !rightArrow) return;
            
            const scrollLeft = container.scrollLeft;
            const maxScroll = container.scrollWidth - container.clientWidth;
            
            leftArrow.style.display = scrollLeft <= 0 ? 'none' : 'block';
            rightArrow.style.display = scrollLeft >= maxScroll - 1 ? 'none' : 'block';
        };
        
        if (tabsMenu && tabLeftArrow && tabRightArrow) {
            updateArrowStates(tabsMenu, tabLeftArrow, tabRightArrow);
        }
        
        document.querySelectorAll('.fixtures-track-container').forEach(container => {
            const track = container.querySelector('.fixtures-track');
            const left = container.querySelector('.scroll-arrow.left');
            const right = container.querySelector('.scroll-arrow.right');
            if (track && left && right) {
                updateArrowStates(track, left, right);
            }
        });
    }, 100);
    
    // Auto-scroll function to live matches
    function autoScrollToLiveMatch() {
        const activeContainer = document.querySelector('.round-fixtures[style*="block"]');
        if (!activeContainer) return;
        
        const track = activeContainer.querySelector('.fixtures-track');
        if (!track) return;
        
        const liveMatches = activeContainer.querySelectorAll('.fixture-card.fixture-live');
        
        if (liveMatches.length > 0) {
            const firstLiveMatch = liveMatches[0];
            
            // Calculate scroll position to center the live match
            const trackRect = track.getBoundingClientRect();
            const matchRect = firstLiveMatch.getBoundingClientRect();
            const trackScrollLeft = track.scrollLeft;
            
            // Calculate the position of the match relative to the track
            const matchLeft = firstLiveMatch.offsetLeft;
            const trackWidth = track.clientWidth;
            const matchWidth = firstLiveMatch.offsetWidth;
            
            // Center the match in the track
            const scrollPosition = matchLeft - (trackWidth / 2) + (matchWidth / 2);
            
            // Ensure we don't scroll past the boundaries
            const maxScroll = track.scrollWidth - trackWidth;
            const finalScrollPosition = Math.max(0, Math.min(scrollPosition, maxScroll));
            
            track.scrollTo({
                left: finalScrollPosition,
                behavior: 'smooth'
            });
        }
    }
    
    // Listen for Firebase score updates specifically
    // This will be triggered by the FirebaseProvider when scores are updated
    window.addEventListener('firebaseScoreUpdated', function(event) {
        // Reapply team highlighting after score updates
        applyTeamHighlighting();
        
        // Auto-scroll to live matches if needed
        autoScrollToLiveMatch();
        
        // Update UI elements that might need refreshing
        debouncedInit();
    });
    
    // Also trigger auto-scroll on initial page load (after Firebase has initialized)
    setTimeout(() => {
        autoScrollToLiveMatch();
    }, 600);

    /*
     * Re-highlight whenever the fan changes.
     *
     * The Auth0 SDK answers asynchronously, so the pass above almost always runs before there is
     * an answer -- this is what actually applies the highlight on a cold page. It also covers a
     * sign-out and a club change while the page is open, both of which the cookie version could
     * not: it read once, at DOMContentLoaded, and never again.
     *
     * `urc-auth:changed` rather than an import: the auth bundle is a separate Vite entry and
     * dispatches this event on `window` for consumers that must not import from it (D-055). The
     * direct subscribe covers a contract that is already there, which is the bfcache case.
     */
    window.addEventListener('urc-auth:changed', applyTeamHighlighting);

    if (window.urcAuth && typeof window.urcAuth.subscribe === 'function') {
        window.urcAuth.subscribe(applyTeamHighlighting);
    }
});